<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { IDECONSTANT } from '@/utils/ide'
import { useIdeStore } from '@/stores/ide.store'
import editorService from '@/services/ide/editor.service'
import OutputFooterComp from '@/components/ide/ide/OutputFooterComp.vue'

const ideStore = useIdeStore()

const isDefaultIde = computed(() => {
  return ideStore.isDefaultIde
})
const isFullScreen = computed(() => {
  return ideStore.isFullScreen
})
const isOutputEditor = computed(() => {
  return ideStore.outputEditor
})
//When resizing screen from desktop -> mobile, need to resize output editor
onMounted(() => {
  if (!isDefaultIde.value && useIdeStore().outputEditor != null) editorService.destroyOutputEditor()
  const timer = ideStore.currentMobileTab == null ? 200 : 500

  setTimeout(() => {
    if (!isDefaultIde.value) editorService.initOutputEditor()
  }, timer)
})
</script>

<template>
  <div
    :class="[
      'surface-secondary-header flex h-auto  w-full flex-col overflow-auto print:break-inside-avoid print:border print:p-1',
      {
        'min-w-full max-w-md': isFullScreen
      }
    ]"
  >
    <div>
      <div class="w-full" id="ideOutputEditor">
        <div
          :id="IDECONSTANT.OUTPUT_EDITOR"
          data-testid="OutputEditor"
          v-show="isOutputEditor"
          class="stroke-secondary-default w-full border border-opacity-80 bg-black text-white caret-white"
        />
      </div>
    </div>
    <OutputFooterComp />
  </div>
</template>
